<template>
  <div>
  </div>
</template>
<script>
import { getLocalCity } from "@/utils/tool.js";
export default {
  data() {
    return {
    };
  },
  created() {
    //获取adcode
    getLocalCity().then((res) => {
      if (res && (res.adCode || res.adcode)) {
        const code = res.adCode || res.adcode;
        console.log('获取定位信息====',res)
        this.chooseCpList(res);
      } else {
        this.chooseCity(res);
      }
    }).catch((e) => {
      this.chooseCity(e);
    })
  },
  methods: {
    // 选择开通城市
    chooseCity(res) {
      this.$router.replace({
        path:'cityList',
        query:{
          cityCode: res.adcode,
          city: res.city,
        }
      })
    },
    // 选择sp列表
    chooseCpList(res) {
      this.$router.replace({
        path:'cpList',
        query:{
          cityCode: res.adcode,
          city: res.city
        }
      })
    }
  }
}
</script>
<style scoped>
</style>
